import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const sarcoidosis: AnswerPathTreeNode = {
  path: 'sarcoidosis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredSarcoidosisDetails }],
};
